/* eslint camelcase: 0 */

// Como en el fork legacy, asignar un valor también DECLARA la variable (una `let` en 0)
// en vez de declararlas todas juntas en init(). Ver variableDeclarations.js.

import { declareVariable } from './variableDeclarations';

export const variables_javascript_get_dynamic = (block, generator) => {
  const name = generator.getVariableName(block.getFieldValue('VAR'));

  return [name, generator.ORDER_ATOMIC];
};

export const variables_javascript_set_dynamic = (block, generator) => {
  const name = generator.getVariableName(block.getFieldValue('VAR'));
  const value = generator.valueToCode(block, 'VALUE', generator.ORDER_ASSIGNMENT) || '0';

  declareVariable(generator, name);

  return `${name} = ${value}\n`;
};

export const variables_javascript_change_dynamic = (block, generator) => {
  const name = generator.getVariableName(block.getFieldValue('VAR'));
  const value = generator.valueToCode(block, 'VALUE', generator.ORDER_ADDITION) || '0';

  declareVariable(generator, name);

  return `${name} += ${value}\n`;
};

// Los perfiles del drone usan los bloques de variable normales y no la categoría
// dinámica; el fork los reescribió con el mismo criterio, así que comparten cuerpo.
export const variables_get = variables_javascript_get_dynamic;
export const variables_set = variables_javascript_set_dynamic;
